"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserSessionIntegration = void 0;

var _browserUtils = require("@sentry-internal/browser-utils");

var _core = require("@sentry/core");

var _debugBuild = require("../debug-build.js");

var _helpers = require("../helpers.js");

/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */
const browserSessionIntegration = exports.browserSessionIntegration = (0, _core.defineIntegration)(() => {
  return {
    name: 'BrowserSession',

    setupOnce() {
      if (typeof _helpers.WINDOW.document === 'undefined') {
        _debugBuild.DEBUG_BUILD && _core.logger.warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
        return;
      } // The session duration for browser sessions does not track a meaningful
      // concept that can be used as a metric.
      // Automatically captured sessions are akin to page views, and thus we
      // discard their duration.


      (0, _core.startSession)({
        ignoreDuration: true
      });
      (0, _core.captureSession)(); // We want to create a session for every navigation as well

      (0, _browserUtils.addHistoryInstrumentationHandler)(({
        from,
        to
      }) => {
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
          (0, _core.startSession)({
            ignoreDuration: true
          });
          (0, _core.captureSession)();
        }
      });
    }

  };
});